import { render } from "./BankingTransaction.vue?vue&type=template&id=d7bc93a2"
import script from "./BankingTransaction.vue?vue&type=script&lang=js"
export * from "./BankingTransaction.vue?vue&type=script&lang=js"
script.render = render

export default script